var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 179,
    viewBox: "0 0 48 179",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_2493)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.34 44.27L30.34 60.5",
    stroke: "#FFCD83",
    strokeWidth: 2.07,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5044 67.4939C20.3524 72.3746 23.3752 77.2649 28.2558 78.4169C33.1365 79.5688 38.0268 76.5461 39.1788 71.6654C40.3307 66.7848 37.308 61.8944 32.4273 60.7425C27.5467 59.5905 22.6563 62.6133 21.5044 67.4939Z",
    stroke: "#FFCD83",
    strokeWidth: 2.07,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.53 94.3C24.25 92.02 24.25 88.33 26.53 86.05C28.81 83.77 32.5 83.77 34.78 86.05C37.06 88.33 37.06 92.02 34.78 94.3C32.5 96.58 28.81 96.58 26.53 94.3Z",
    fill: "#FFCD83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.34 102.19L30.34 166.03",
    stroke: "#FFCD83",
    strokeWidth: 2.07,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.34 66.44L33.95 64.03L32.77 68.2L36.17 70.89L31.84 71.06L30.34 75.12L28.84 71.06L24.51 70.89L27.91 68.2L26.74 64.03L30.34 66.44Z",
    fill: "#FFCD83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.67 177.18C26.2 175.71 26.2 173.32 27.67 171.85C29.14 170.38 31.53 170.38 33 171.85C34.47 173.32 34.47 175.71 33 177.18C31.53 178.65 29.14 178.65 27.67 177.18Z",
    fill: "#FFCD83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.22 154.83C23.94 152.55 23.94 148.86 26.22 146.58C28.5 144.3 32.19 144.3 34.47 146.58C36.75 148.86 36.75 152.55 34.47 154.83C32.19 157.11 28.5 157.11 26.22 154.83Z",
    fill: "#FFCD83"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_2493"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47.95,
    height: 178.28,
    fill: "white",
    transform: "translate(47.95 178.28) rotate(-180)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine);
export default __webpack_public_path__ + "static/media/line.7b0840fd873ac6a2956536d62ad8507c.svg";
export { ForwardRef as ReactComponent };